// extracted by mini-css-extract-plugin
export default {"quickBlock":"social-block_quickBlock__tKSAO"};